<div *ngIf="isLoading | async" class="overlay">
<div class="spinner"></div>
</div>